import React from 'react'
import { Box, Alert, Link, TextBody } from '@ally/metronome-ui'

const DebtPlanError = (): JSX.Element => {
  return (
    <Box mb="sm" data-testid="debt-plan-outage-card">
      <Alert
        variant="error"
        heading={
          <TextBody tag="span" size="sm" weight="bold">
            We&apos;ve hit a snag when trying to update your plan information.
          </TextBody>
        }
        body={
          <TextBody tag="p" size="sm">
            But, good news, a fix is in the works and you can still access your
            plan. <Link to="/debt-plan" text="Review Plan" />
          </TextBody>
        }
      />
    </Box>
  )
}

export default DebtPlanError
